import { LineItemType } from "@wingspanhq/wingspan-api-sdk";
import { FormDataLineItem } from "../components/InvoicesForm/LineItemsSection/types";

/**
 * Resolves the v3 `lineItemType` to write for a form line item.
 *
 * The form models the type as a single reimbursable-expense checkbox, so the
 * only type it can produce is `Reimbursement`. Any other type the line item
 * already carried (`Bonus`, `Commission`, …) passes through untouched rather
 * than being flattened by an edit that never offered a way to change it — the
 * one exception being `Reimbursement` itself, which falls back to `Services`
 * when the box is unchecked.
 */
export const selectorLineItemTypeFromFormData = (
  lineItem: FormDataLineItem
): LineItemType | undefined => {
  if (lineItem.reimbursableExpense) {
    return LineItemType.REIMBURSEMENT;
  }

  return lineItem.lineItemType === LineItemType.REIMBURSEMENT
    ? LineItemType.SERVICES
    : lineItem.lineItemType;
};
